'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _FormValidationService = require('./../../../common/services/FormValidationService');

var _FormValidationService2 = _interopRequireDefault(_FormValidationService);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactEditController = function () {
  function ContactEditController(authService, $stateParams, enums, contactService, loadingService, $state, appConfig, $scope, utilsService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ContactEditController);
    this.authService = authService;
    this.enums = enums;
    this.contactService = contactService;
    this.loadingService = loadingService;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.utilsService = utilsService;

    this.formValidationService = new _FormValidationService2.default();

    var permissionToCheck = void 0;
    if ($stateParams.companyId) {
      permissionToCheck = enums.PERMISSION_TYPE.Edit;
    } else {
      permissionToCheck = enums.PERMISSION_TYPE.Add;
    }

    if (!authService.validateUser(false, 'Contact', permissionToCheck, true)) {
      return;
    }

    this.searchCompanyUrl = appConfig.apiServiceBaseUri + 'api/company/search/' + authService.authData.currentLocation.key + '/';
    this.searchUsersUrl = appConfig.apiServiceBaseUri + 'api/user/search/' + authService.authData.currentLocation.key + '/';

    this.dtPopups = {}; //Cleanup
    this.yearsCollection = this.getYearsCollection();
    this.monthsCollection = this.getMonthsCollection();

    this.panels = {
      contact: true
    };

    this.contact = {
      entityId: authService.authData.currentLocation.key,
      ownerId: authService.authData.userId,
      contactPerson: {
        title: this.enums.PERSON_TITLE.Mr
      },
      partner: {},
      address: {},
      previousAddress: {},
      employerAddress: {},
      prevEmployerAddress: {},
      contactPhones: [],
      contactEmails: [],
      notes: [],
      yearsAtAddress: null,
      monthsAtAddress: null,
      yearsAtPrevAddress: null,
      monthsAtPrevAddress: null,
      yearsAtEmployment: null,
      monthsAtEmployment: null,
      yearsAtPrevEmployment: null,
      monthsAtPrevEmployment: null,
      yearsAtBank: null,
      monthsAtBank: null
    };
    this.selectOptions = {};
    this.selectDefaults = {};

    this.initializeEnums();
    this.configureForm();

    this.initialCompanyName = '';
    this.initialOwnerName = '';
    this.loadContact();

    this.companySelected = this.companySelected.bind(this);
    this.ownerSelected = this.ownerSelected.bind(this);

    this.origin = $stateParams.origin;
  }

  (0, _createClass3.default)(ContactEditController, [{
    key: 'initializeEnums',
    value: function initializeEnums() {
      var ctrl = this;
      var enumList = [{ enumName: 'CONTACT_TYPE', propName: 'contactType' }, { enumName: 'PERSON_TITLE', propName: 'contactPerson.title' }, { enumName: 'CONTACT_METHOD', propName: 'contactMethod', defaultOption: true }, { enumName: 'PERSON_TITLE', propName: 'partner.title', defaultOption: true }, { enumName: 'GENDER', propName: 'gender', defaultOption: true }, { enumName: 'MARITAL_STATUS', propName: 'maritalStatus', defaultOption: true }, { enumName: 'RESIDENCE_TYPE', propName: 'residenceType', defaultOption: true }, { enumName: 'EMPLOYMENT_TYPE', propName: 'employmentType', defaultOption: true }];

      enumList.map(function (item) {
        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName], item.defaultOption);
        ctrl.selectOptions[item.propName] = enumsArray;
        ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
        ctrl.updateModelFromSelect(item.propName);
      });
    }
  }, {
    key: 'getDefaultOption',
    value: function getDefaultOption(enumsArray, propName) {
      var propVal = void 0;

      try {
        propVal = eval('this.contact.' + propName);
      } catch (e) {}

      if (propVal) {
        return (0, _lodash.find)(enumsArray, function (o) {
          return o.id === propVal;
        });
      } else {
        return enumsArray[0];
      }
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'updateModelFromSelect',
    value: function updateModelFromSelect(modelProperty) {
      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

      var val = this.selectDefaults[selectDefaultProperty][idProperty];

      try {
        eval('this.contact.' + modelProperty + ' = ' + val);
      } catch (e) {}
    }
  }, {
    key: 'configureForm',
    value: function configureForm() {
      var ctrl = this;

      ctrl.formValidationService.initialize(ctrl.contact);

      ctrl.formValidationService.addField({
        fieldName: 'firstName',
        displayName: 'First Name',
        model: ctrl.contact.contactPerson,
        required: true,
        stringLength: {
          min: 3,
          max: 50
        }
      });

      ctrl.formValidationService.addField({
        fieldName: 'lastName',
        displayName: 'Last Name',
        model: ctrl.contact.contactPerson,
        required: true,
        stringLength: {
          min: 3,
          max: 50
        }
      });

      ctrl.formValidationService.addField({
        fieldName: 'firstName',
        displayName: 'Partner First Name',
        model: ctrl.contact.partner,
        condition: '{MODEL}.partner && {MODEL}.partner.title',
        required: true,
        stringLength: {
          min: 3,
          max: 50
        }
      });

      ctrl.formValidationService.addField({
        fieldName: 'lastName',
        displayName: 'Partner Last Name',
        model: ctrl.contact.partner,
        condition: '{MODEL}.partner && {MODEL}.partner.title',
        required: true,
        stringLength: {
          min: 3,
          max: 50
        }
      });

      var checkDpa = true;

      if (!this.contact.contactId) {
        if (this.$stateParams.origin.source === 'welcomeCentre') {
          checkDpa = false;
        }
      }

      this.$scope.$broadcast('parentFormConfigured');
    }
  }, {
    key: 'loadContact',
    value: function loadContact() {
      var ctrl = this;

      if (ctrl.$stateParams.contact) {
        /*
        * If there is a contact in State Params
        * This means that we wanted to create a Company while Adding / Updating a contact
        * And we passed the same contact object back, which we sent before creating the company
        */
        (0, _assign2.default)(ctrl.contact, ctrl.$stateParams.contact);
        ctrl.initialCompanyName = ctrl.$stateParams.companyName;
        ctrl.initialOwnerName = ctrl.$stateParams.contact.ownerName;
        this.configureForm();
      } else if (ctrl.$stateParams.contactId) {
        ctrl.loadingService.showLoading('editContact', 'Loading Contact ...');

        ctrl.contactService.getContact(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.contactId).then(function (response) {
          (0, _assign2.default)(ctrl.contact, response.data);
          ctrl.contact.dateOfBirth = ctrl.utilsService.getDatePart(ctrl.contact.dateOfBirth);
          ctrl.contact.workPermitExpiry = ctrl.utilsService.getDatePart(ctrl.contact.workPermitExpiry);
          ctrl.contact.partner = ctrl.contact.partner || {};
          ctrl.contact.previousAddress = ctrl.contact.previousAddress || {};
          ctrl.contact.employerAddress = ctrl.contact.employerAddress || {};
          ctrl.contact.prevEmployerAddress = ctrl.contact.prevEmployerAddress || {};
          ctrl.initialCompanyName = response.data.companyName;
          ctrl.initialOwnerName = response.data.ownerName;
          ctrl.initializeEnums();
          ctrl.configureForm();
        }).catch(function (err) {}).finally(function () {
          ctrl.loadingService.hideLoading('editContact');
        });
      } else {
        /*
        * Its a New Contact
        * Set the Initial Owner Name
        */
        this.initialOwnerName = ctrl.authService.authData.firstName + ' ' + ctrl.authService.authData.lastName;
      }
    }
  }, {
    key: 'companySelected',
    value: function companySelected(item) {
      if (item) {
        this.contact.companyId = item.originalObject.companyId;
      }
    }
  }, {
    key: 'clearCompany',
    value: function clearCompany() {
      this.contact.companyId = null;
      this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchCompanies');
    }
  }, {
    key: 'ownerSelected',
    value: function ownerSelected(item) {
      if (item) {
        this.contact.ownerId = item.originalObject.userId;
      }
    }
  }, {
    key: 'redirectToParent',
    value: function redirectToParent(newContactId) {
      if (!this.origin.source) {
        this.$state.go('contactList');
      } else {
        var output = this.origin.processResult(newContactId, this.contact);

        this.$state.go(output.stateName, output.params);
      }
    }
  }, {
    key: 'editContact',
    value: function editContact() {
      var _this = this;

      var ctrl = this;

      if (!ctrl.formValidationService.validateForm()) {
        return;
      }

      if (!ctrl.contact.partner || !ctrl.contact.partner.title) {
        ctrl.contact.partner = null;
      }

      //Convert Dpa to GDPR for saving
      this.contact.contactGDPR = (0, _assign2.default)({}, this.contact.dpa);

      this.state = 'Saving';

      ctrl.loadingService.showLoading('editContact', 'Saving Changes ...');

      ctrl.contactService.editContact(ctrl.contact).then(function (response) {
        _this.state = 'Saved';
        ctrl.redirectToParent(response.data);
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          ctrl.state = 'ModelError';

          err.data.map(function (item) {
            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        } else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editContact');
      });
    }
  }, {
    key: 'canEdit',
    value: function canEdit() {
      var ctrl = this;
      var retValue = false;

      if (!ctrl.contact.contactId) {
        return true;
      }

      retValue = ctrl.authService.checkFeatureAccess('Contact', ctrl.enums.PERMISSION_TYPE.Edit, false) && ctrl.contact.state !== ctrl.enums.OBJECT_ROW_STATE.Deleted;

      return retValue;
    }
  }, {
    key: 'showDatePopup',
    value: function showDatePopup(id) {
      this.dtPopups[id] = true;
    }
  }, {
    key: 'getYearsCollection',
    value: function getYearsCollection() {
      return [{ id: null, name: 'Please Select' }, { id: 0, name: '0 Years' }, { id: 1, name: '1 Year' }, { id: 2, name: '2 Years' }, { id: 3, name: '3 Years' }, { id: 4, name: '4 Years' }, { id: 5, name: '5+ Years' }];
    }
  }, {
    key: 'getMonthsCollection',
    value: function getMonthsCollection() {
      return [{ id: null, name: 'Please Select' }, { id: 1, name: '1 Month' }, { id: 2, name: '2 Months' }, { id: 3, name: '3 Months' }, { id: 4, name: '4 Months' }, { id: 5, name: '5 Months' }, { id: 6, name: '6 Months' }, { id: 7, name: '7 Months' }, { id: 8, name: '8 Months' }, { id: 9, name: '9 Months' }, { id: 10, name: '10 Months' }, { id: 11, name: '11 Months' }, { id: 12, name: '12 Months' }];
    }
  }]);
  return ContactEditController;
}();

exports.default = ContactEditController;


// WEBPACK FOOTER //
// ./client/app/components/contact/contactEdit/contactEdit.controller.js